/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Live_Implausible_Assisted_BodyInputs */

const en_us2_workout_live_implausible_assisted_body = /** @type {(inputs: Workout_Live_Implausible_Assisted_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The assistance is more than your body weight.`)
};

const pt_br2_workout_live_implausible_assisted_body = /** @type {(inputs: Workout_Live_Implausible_Assisted_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A assistência passa do seu peso corporal.`)
};

const es_419_workout_live_implausible_assisted_body = /** @type {(inputs: Workout_Live_Implausible_Assisted_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La asistencia supera tu peso corporal.`)
};

const pt_pt2_workout_live_implausible_assisted_body = /** @type {(inputs: Workout_Live_Implausible_Assisted_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A assistência ultrapassa o teu peso corporal.`)
};

const fr_fr2_workout_live_implausible_assisted_body = /** @type {(inputs: Workout_Live_Implausible_Assisted_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'assistance dépasse ton poids de corps.`)
};

const de_de2_workout_live_implausible_assisted_body = /** @type {(inputs: Workout_Live_Implausible_Assisted_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Unterstützung ist größer als dein Körpergewicht.`)
};

const it_it2_workout_live_implausible_assisted_body = /** @type {(inputs: Workout_Live_Implausible_Assisted_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'assistenza supera il tuo peso corporeo.`)
};

/**
* | output |
* | --- |
* | "The assistance is more than your body weight." |
*
* @param {Workout_Live_Implausible_Assisted_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_implausible_assisted_body = /** @type {((inputs?: Workout_Live_Implausible_Assisted_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_Implausible_Assisted_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_implausible_assisted_body(inputs)
	if (locale === "es-419") return es_419_workout_live_implausible_assisted_body(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_implausible_assisted_body(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_implausible_assisted_body(inputs)
	if (locale === "de-DE") return de_de2_workout_live_implausible_assisted_body(inputs)
	if (locale === "it-IT") return it_it2_workout_live_implausible_assisted_body(inputs)
	return en_us2_workout_live_implausible_assisted_body(inputs)
});
export { workout_live_implausible_assisted_body as "workout-live.implausible_assisted_body" }